<script lang="ts">
    import {Kind} from 'shared/constants';
    import type {RecordOperation} from 'src/typings';
    import {getDateFormatter, getLocalization} from 'src/core';
    import {pipe} from 'core/utils';
    import Label from 'shared/components/kp-label/Label.svelte';

    export let operation: RecordOperation;

    const dateFormatter = getDateFormatter();
    const localize = getLocalization();
</script>

<div class="record-operation-mini">
    <div class="details">
        <strong><Label labeled={operation.recordOperationType}/></strong>

        <span class="text-muted">{localize(/* @kp-localization commons.byUser */ 'commons.byUser')}</span>
        <Label labeled={operation.user} explicitKind={Kind.KIND_USER}/>

        <span class="text-muted">na</span>
        <span><Label labeled={operation.department}/></span>
    </div>

    <div class="timestamp">
        <span>{pipe(operation.date, dateFormatter('d.M.yyyy'))}</span>
        <span class="text-muted">{pipe(operation.date, dateFormatter('HH:mm'))}</span>
    </div>
</div>

<style lang="less">
    .record-operation-mini {
        display: flex;
        justify-content: space-between;

        .timestamp {
            white-space: nowrap;
        }
    }
</style>